module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "introMusic",
      "preload": "auto",
      "src": "/static/audio/intro.mp3",
      "loop": "loop"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "gamingMusic",
      "preload": "auto",
      "src": "/static/audio/gaming.mp3",
      "loop": "loop"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "gamingMusicB",
      "preload": "auto",
      "src": "/static/audio/gamingBride.mp3",
      "loop": "loop"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "endingMusic",
      "preload": "auto",
      "src": "/static/audio/ending.mp3",
      "loop": "loop"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "catchMusic",
      "preload": "auto",
      "src": "/static/audio/catch.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "powerUpMusic",
      "preload": "auto",
      "src": "/static/audio/powerUp.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "selectMusic",
      "preload": "auto",
      "src": "/static/audio/select.mp3"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3310d047","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 449
// module chunks = 0